import React from "react";


export default function Header() {
  return (
    <div style={{ textAlign: "left" }}>
      <a href="https://www.arbolunderwriters.com/" target="_blank" rel="noopener noreferrer">
        <img
          width={100}
          src="/logo.png"
          alt="Logo" 
        />
      </a>
    </div>
  );
}
